export enum FieldEnum {
	Address = 'composedAddrTx',
	Agent = 'composedAgentNm',
	ListingStatus = 'listingStatusCd',
	TransactionStatusCd = 'transactionStatusCd',
	ListingDate = 'listedDt',
	OffMarketDate = 'offMarketDt',
	ListPrice = 'listPriceAm',
	UpdateTime = 'updateTime',
	ContractDate = 'contractDt',
	EstimatedCloseDate = 'estimatedCloseDt',
	CloseDate = 'closeDt',
	SalePrice = 'salePriceAm',
	AverageBrokerCommissionRate = 'avgBrokerCommissionRt',
}

export enum ColumnType {
	Number = 'number',
	String = 'string',
}
